import { useEffect, useState } from "react";
import useTransportOrderService from "../../../app/services/hooks/useTransportOrderService";
import { TransportOrderFilters } from "../../../app/models/TransportOrder";
import { ServiceResponse } from "../../../app/services/shared/interfaces";
import { toast } from "react-toastify";
import { formatMoney } from "../../../utils/utils";
import useExpenseService from "../../../app/services/hooks/useExpenseService";
import { ExpenseDataForm, ExpenseFilters } from "../../../app/models/Expense";
import useTollExpenseService from "../../../app/services/hooks/useExpenseTollService";
import { TollExpenseFilters } from "../../../app/models/TollExpense";
import CommissionsDataTable from "./tables/CommissionsDataTable";
import ExpensesByWorkerDataTable from "./tables/ExpensesByWorkerDataTable";
import TollExpensesByWorkerDataTable from "./tables/TollExpensesByWorkerDataTable";


interface Props {
    expensesFilter: ExpenseFilters;
    setExpensesFilter: (expensesFilter: ExpenseFilters) => void;
    tollExpensesFilter: TollExpenseFilters;
    setTollExpensesFilter: (tollExpensesFilter: TollExpenseFilters) => void;
    setTollExpensesTotalAmount: (total: number) => void;
    tollExpensesTotalAmount: number;
    setExpensesTotalAmount: (total: number) => void;
    expensesTotalAmount: number;
    searchAction: boolean
}

const ExpensesContainer = ({ 
    expensesFilter,
    setExpensesFilter,
    tollExpensesFilter,
    setTollExpensesFilter,
    setTollExpensesTotalAmount,
    tollExpensesTotalAmount,
    setExpensesTotalAmount,
    expensesTotalAmount,
    searchAction
}: Props) => {



    // GASTOS
    const { getExpensesTotalAmount, 
        getNonTollExpenses,
        fetchingGetExpensesTotalAmount,
        fetchingGetNonTollExpenses } = useExpenseService();

    const [expensesShowDataTable, setExpensestShowDataTable] = useState<boolean>(false);
    const [expenses, setExpenses] = useState<ExpenseDataForm[]>([]);
    const [expensesTotalRows, setExpensesTotalRows] = useState(0);

    useEffect(()=>{

        if(expensesFilter.worker_id){
            getExpensesTotalAmount(expensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setExpensesTotalAmount(response.data.total_amount)
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }

    },[searchAction]);

    useEffect(()=>{
        if(expensesShowDataTable){
            getNonTollExpenses(expensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setExpenses(response.data.expenses);
                    setExpensesTotalRows(response.data.total_rows);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    },[searchAction, expensesShowDataTable, expensesFilter.page, expensesFilter.per_page]);

    const showExpensesData = () => {
        setExpensestShowDataTable(!expensesShowDataTable)
    };


   //PEAJES
    const {getTollExpenseSumByWorker, 
        getAllTollExpenses,
        fetchingGetTollExpensesSum,
        fetchingGetTollExpenses} = useTollExpenseService()

    const [tollExpensesShowDataTable, setTollExpensestShowDataTable] = useState<boolean>(false);
    const [tollExpenses, setTollExpenses] = useState<ExpenseDataForm[]>([]);
    const [tollExpensesTotalRows, setTollExpensesTotalRows] = useState(0);

    const showTollExpensesData = () => {
        setTollExpensestShowDataTable(!tollExpensesShowDataTable)
    };

    useEffect(()=>{
        if(tollExpensesShowDataTable){
            getAllTollExpenses(tollExpensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setTollExpenses(response.data.toll_expenses);
                    setTollExpensesTotalRows(response.data.total_rows);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    },[searchAction, tollExpensesShowDataTable, tollExpensesFilter.page, tollExpensesFilter.per_page]);

    useEffect(()=>{

        if(tollExpensesFilter.worker_id){
            getTollExpenseSumByWorker(tollExpensesFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setTollExpensesTotalAmount(response.data.total_amount)
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }

    },[searchAction]);

    

    return (
        <>
           <div className="row justify-content-start">

                {/* PEAJES*/}
                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showTollExpensesData}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium " style={{ userSelect: 'none' }}>Peajes</p>
                                {fetchingGetTollExpensesSum ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(tollExpensesTotalAmount)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div> 

                {tollExpensesShowDataTable && tollExpenses.length > 0 ? 
                    (              
                        <div className="col-lg-10 mb-4">
                            <div className="h5">Detalle Peajes</div>
                            <TollExpensesByWorkerDataTable 
                                data={tollExpenses}
                                progressPending={fetchingGetTollExpenses}
                                totalRows={tollExpensesTotalRows}
                                filter={tollExpensesFilter}
                                setFilter={setTollExpensesFilter}
                            />
                        </div>
                    ) : (null) 
                }  


                {/* OTROS GASTOS*/}
                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showExpensesData}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium " style={{ userSelect: 'none' }}>Otros Gastos</p>
                                {fetchingGetExpensesTotalAmount ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(expensesTotalAmount)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>  

                {expensesShowDataTable && expenses.length > 0 ? 
                    (               
                        <div className="col-lg-10 mb-4">
                            <div className="h5">Detalle Gastos</div>
                            <ExpensesByWorkerDataTable 
                                data={expenses}
                                progressPending={fetchingGetNonTollExpenses}
                                totalRows={expensesTotalRows}
                                filter={expensesFilter}
                                setFilter={setExpensesFilter}
                            />
                        </div>
                    ) : (null)  
                } 

           </div>
        </>
    )

}

export default ExpensesContainer;